module.exports = __webpack_public_path__ + "static/media/buzzwords_words_live.3c855ce3.png";